import styled from 'styled-components';
import Discount from 'ggApp/shared/icons/Discount';

export const VoucherPreviewWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const VoucherIconAndText = styled.div`
    display: flex;
    align-items: center;
`;

export const DiscountIcon = styled(Discount)`
    margin-right: 8px;
`;

export const VoucherText = styled.div`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors.Color2};
    text-decoration: underline;
`;

export const VoucherAmount = styled.div`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors.Color2};
`;
